import ReactPixel from "react-facebook-pixel";
import { moduleSettings } from "../stores/module-settings.store";

const options = {
  autoConfig: true,
  debug: false,
};

class FacebookPixelService {
  facebookPixelModuleInitialized: boolean = false;
  hasConsent: boolean = false;
  static service: FacebookPixelService | undefined;

  static get(): FacebookPixelService {
    if (!this.service) {
      this.service = new FacebookPixelService();
    }
    return this.service!;
  }

  initFacebookPixel() {
    const externalPartner = moduleSettings.externalPartner;
    if (externalPartner?.facebook_pixel_id) {
      ReactPixel.init(externalPartner.facebook_pixel_id, undefined, options);
      this.facebookPixelModuleInitialized = true;
      this.revokeConsent();
    }
  }

  revokeConsent() {
    this.hasConsent = false;
    if (this.facebookPixelModuleInitialized) {
      ReactPixel.revokeConsent();
    }
  }

  grantConsent() {
    this.hasConsent = true;
    if (this.facebookPixelModuleInitialized) {
      ReactPixel.grantConsent();
    }
  }
}

export default FacebookPixelService.get();
